import React from 'react';
import { getCachedMediaUrl } from '../../../../lib/utils/utils';

function RecentOrderBar({ orderStatus, order, statusColors }) {
    return (
        <div className="border-t border-[#EAEAEA] flex items-center">
            <div className="w-[30%] p-[6px_10px_6px_16px] flex items-center gap-2">
                <img className='size-11 rounded-[5.5px] object-cover' src={getCachedMediaUrl(order.Product.productImgUrls[0])} alt="" />

                <h1 className='w-[calc(100%-44px)] text-[#121212] font-medium text-[14px] leading-6 line-clamp-1'>{order.Product.productName}</h1>
            </div>

            <div className="w-[14%] px-[10px] py-[18px]">
                <h2 className='font-normal text-[14px] leading-6 text-[#121212]'>#{order.orderId.slice(-6)}</h2>
            </div>

            <div className="w-[14%] px-[10px] py-[18px]">
                <h2 className='font-normal text-[14px] leading-6 text-[#121212]'>{order.quantity}</h2>
            </div>

            <div className="w-[14%] px-[10px] py-[18px]">
                <h2 className='font-normal text-[14px] leading-6 text-[#121212]'>₹{order.price}</h2>
            </div>

            <div className="w-[14%] px-[10px] py-[18px]">
                <h2 className='font-normal text-[14px] leading-6 text-[#121212]'>₹{order.total}</h2>
            </div>

            <div className="w-[14%] px-[10px] py-[28px]">
                <h2 
                    className={`
                        w-fit text-center font-medium text-[14px] leading-5 
                        px-3 py-[2px] rounded-xl 
                        ${statusColors}
                    `}
                >
                    {orderStatus}
                </h2>
            </div>
        </div>
    )
}

export default RecentOrderBar;
